import RequiringCoveragesService from './RequiringCoveragesService'

export default RequiringCoveragesService
